import {Box} from "@mui/material";
import Utils from "@/components/Shared/Utils";

export default function ObjectFilter({label, callback, fullWidth = false}: {
    label: string,
    callback: any,
    fullWidth?: boolean
}) {
    return (
        <Box minWidth={fullWidth ? '100%' : 300} width={fullWidth ? '100%' : 300}>
            <Utils.FormUtils.PrimaryInput
                onChange={(event: any) => callback(event.target.value !== "" && event.target.value || null)}
                size="small"
                type="text"
                label={label}
                InputLabelProps={{
                    sx: {
                        fontSize: 13
                    }
                }}
                inputProps={{
                    sx: {
                        fontSize: 13,
                        bgcolor: 'white'
                    }
                }}
                sx={{
                    border: 'none',
                    ".MuiInputLabel-shrink": {transform: 'translate(14px, -9px)'}
                }}
            />
        </Box>
    )
}